import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "./LangContext";
import "../styles/Crops.css";
import { FaArrowRight } from "react-icons/fa";

// Placeholder data for crops. User can replace the image URLs later.
const cropsData = [
  { id: "sugarcane", key: "crop_sugarcane", image: "https://via.placeholder.com/400x300?text=Sugarcane" },
  { id: "grape", key: "crop_grape", image: "https://via.placeholder.com/400x300?text=Grape" },
  { id: "coffee", key: "crop_coffee", image: "https://via.placeholder.com/400x300?text=Coffee" },
  { id: "cotton", key: "crop_cotton", image: "https://via.placeholder.com/400x300?text=Cotton" },
  { id: "potato", key: "crop_potato", image: "https://via.placeholder.com/400x300?text=Potato" },
  { id: "cauliflower", key: "crop_cauliflower", image: "https://via.placeholder.com/400x300?text=Cauliflower" },
  { id: "citrus", key: "crop_citrus", image: "https://via.placeholder.com/400x300?text=Citrus" },
  { id: "cashewnut", key: "crop_cashewnut", image: "https://via.placeholder.com/400x300?text=Cashew+nut" },
  { id: "papaya", key: "crop_papaya", image: "https://via.placeholder.com/400x300?text=Papaya"},
  { id: "wheat", key: "crop_wheat", image: "https://via.placeholder.com/400x300?text=Wheat" },
  { id: "paddy", key: "crop_paddy", image: "https://via.placeholder.com/400x300?text=Paddy" },
  { id: "maize", key: "crop_maize", image: "https://via.placeholder.com/400x300?text=Maize" }
];

const Crops = () => {
  const { t } = useLang();

  return (
    <div className="crops-page-container">
      {/* Hero Section */}
      <section className="crops-hero">
        <div className="crops-hero-overlay"></div>
        <div className="crops-hero-content">
          <h1>{t("nav_crops") || "CROPS"}</h1>
          <div className="title-underline"></div>
        </div>
        {/* Concave bottom curve */}
        <div className="hero-curve">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,120 C480,0 960,0 1440,120 L1440,120 L0,120 Z" fill="#ffffff" />
          </svg>
        </div>
      </section>

      {/* Crops Grid Section */}
      <section className="crops-grid-section">
        <div className="crops-grid">
          {cropsData.map((crop) => (
            <div className="crop-card" key={crop.id}>
              {/* Background Image */}
              <div
                className="crop-card-bg"
                style={{ backgroundImage: `url(${crop.image})` }}
                aria-label={t(crop.key) || crop.id}
              ></div>
              <div className="crop-card-gradient"></div>
              
              {/* Visible Content */}
              <div className="crop-card-content">
                <h3>{t(crop.key) || crop.id.charAt(0).toUpperCase() + crop.id.slice(1)}</h3>
                <Link to={`/crops/${crop.id}`} className="read-more-btn">
                  {t("read_more") || "Read More"} <FaArrowRight className="arrow-icon" />
                </Link>
              </div>

              {/* Hover Overlay */}
              <div className="crop-hover-overlay">
                <div className="hover-icon-wrapper">
                  {/* Generic leaf icon as placeholder for vector mascot */}
                  <img src="https://via.placeholder.com/80/ffffff/56ab2f?text=Icon" alt="Hover Icon" className="hover-icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Crops;
